import SnowflakeSlash from './SnowflakeSlash';

export default SnowflakeSlash;
